module.exports = __webpack_public_path__ + "static/media/DKS.9d74e7fa.jpg";